export const useDataAll = defineStore('dataAll', {
  state: () => ({
    data: null,
    siteLabel: "",
    language: "",
    pageType:"",
    defaultLanguage:"",
    languages: [],
    dataVarsKey: reactive({}),
    // isFetching: false,
    // lastFetch: null,
    loadedSuccessfully: true,
    i18nInitialized: false,
    errorStatusCode:null
  }),

  getters: {
    // hasData() {
    //   return this.data !== null
    //     && this.data !== undefined
    //     && Object.keys(this.data).length > 0
    //     && this.lastFetch != null;
    // },
    // shouldFetch() {
    //   // Don't fetch if already fetching
    //   if (this.isFetching) return false;

    //   // Always fetch if no data or no last fetch time
    //   if (!this.data || !this.lastFetch) return true;

    //   const now = Date.now();
    //   return (now - this.lastFetch) > 60 * 60 * 1000; // 1 hour
    // },
  },

  actions: {
    // async fetchDataIfNeeded({ force = false } = {}) {
    //   if (!force && !this.shouldFetch) return this.data;

    //   const { $apiMethods, $methods, $helpers } = useNuxtApp()

    //   this.setIsFetching()
    //   this.setlabel($helpers.getLabelId());

    //   if (import.meta.server) {
    //     this.setLanguageObjects($methods.getLanguageObjects());
    //   }

    //   $apiMethods.generateSecurityParameters()

    //   const language = this.getLanguage();
    //   const label = this.getLabel();
    //   const hostName = this.getDataVar("hostname");

    //   try {
    //     const fetchResult = await dataRepository.fetchAllData(language, label, hostName);

    //     const data = fetchResult.data?.value;
    //     const error = fetchResult.error?.value;

    //     if (error) {
    //       this.setErrorStatusCode (error.statusCode)
    //       this.setDataVar("errorStringLoad", error.message || "Unknown error");
    //       this.set(null);
    //       this.setLoadedSuccessfully(false);
    //       return
    //     } else {
    //       this.setErrorStatusCode (null)
    //     }

    //     if (!data) {
    //       this.setDataVar("errorStringLoad", "No data returned");
    //       this.set(null);
    //       this.setLoadedSuccessfully(false);
    //       return;
    //     }

    //     if (!$methods.checkObjectFieldsExists(data, ['WebPages', 'pageNames', 'StaticText', 'siteJson'], "laden hoofdjson")) {
    //       this.setDataVar("errorStringLoad", "ERROR response = Missende velden in JSON");
    //       this.set(null)
    //       this.setLoadedSuccessfully(false)
    //       return
    //     }

    //     this.set(data);
    //     this.setLoadedSuccessfully(true);

    //     return this.data;

    //   } catch (error) {
    //     this.setDataVar("errorStringLoad", "onRequestError ERROR response = " + error)
    //     this.set(null)
    //     this.setLoadedSuccessfully(false)
    //     throw error
    //   }
    // },
    // setIsFetching() {
    //   this.isFetching = true;
    // },
    // JSON data
    set(dataIN) {
      this.data = dataIN
      // this.isFetching = false;
      // this.lastFetch = Date.now()
    },
    setErrorStatusCode(errorStatusCode){
      this.errorStatusCode = errorStatusCode
    },
    getAll(){
      return this.data;
    },
    getKey(key, defaultValue) {
      if (this.data !== null && typeof (this.data[key]) != "undefined"  ) {
        return this.data[key];
      } else {
        return defaultValue;
      }
    },
    getErrorStatusCode(){
      return this.errorStatusCode
    },
    getStatic(key, defaultValue) {
      if (this.data && typeof (this.data['StaticText']) != "undefined" &&typeof (this.data['StaticText']["'"+key+"'"]) != "undefined" &&  this.data['StaticText']["'"+key+"'"] !== null) {
        return this.data['StaticText']["'"+key+"'"]
      } else if (this.data && typeof (this.data['StaticText']) != "undefined" &&typeof (this.data['StaticText'][key]) != "undefined" &&  this.data['StaticText'][key] !== null) {
        return this.data['StaticText'][key]
      } else {
        return defaultValue;
      }
    },
    // Language Objects (getters en setters)
    // Languages, holds an object with all possible languages
    // language is the current language
    setLanguageObjects(languageObject) {
      this.language = languageObject[0]
      this.languages = languageObject[1]
      this.defaultLanguage = languageObject[2]
    },
    getLanguage() {
      return this.language
    },
    getLanguages() {
      return this.languages
    },
    getDefaultLanguage() {
      return this.defaultLanguage
    },
    // Label (get and set)
    setlabel(labelIn) {
      this.siteLabel = labelIn
    },
    getLabel() {
      return this.siteLabel
    },
    // Key pairs, store key value pairs
    getDataVar(name) {
      if (typeof (this.dataVarsKey[name]) != "undefined" && this.dataVarsKey !== null) {
        return this.dataVarsKey[name]
      } else {
        return "";
      }
    },
    setDataVar(name, value) {
      this.dataVarsKey[name] = value
    },
    setLoadedSuccessfully(value) {
      this.loadedSuccessfully = value
    }
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useDataAll, import.meta.hot))
}
